import { render, staticRenderFns } from "./signList.vue?vue&type=template&id=30cccbac&scoped=true&"
import script from "./signList.vue?vue&type=script&lang=js&"
export * from "./signList.vue?vue&type=script&lang=js&"
import style0 from "./signList.vue?vue&type=style&index=0&id=30cccbac&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30cccbac",
  null
  
)

export default component.exports